/* === FOXDEN Discount Popup (Shopify-safe iframe submit) === */
(function () {
  var POPUP_DELAY_MS = 5000;
  var SUCCESS_CLOSE_MS = 15000;
  var STORAGE_KEY = "foxden-popup-dismissed";

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
  }

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var root = document.getElementById("foxden-popup-root");
    if (!root) return;

    // Already dismissed
    try {
      if (localStorage.getItem(STORAGE_KEY)) return;
    } catch (e) {}

    var form = document.getElementById("foxden-popup-form");
    var emailInput = document.getElementById("foxden-popup-email");
    var success = document.getElementById("foxden-popup-success");
    var declineBtn = root.querySelector(".foxden-popup__decline");

    var copyBtn = document.getElementById("foxden-copy-code");
    var copyMsg = document.getElementById("foxden-copy-msg");
    var codeEl = document.getElementById("foxden-discount-code");

    var openTimer = null;
    var closeTimer = null;
    var hasSubmitted = false;

    function setDismissed() {
      try {
        localStorage.setItem(STORAGE_KEY, "true");
      } catch (e) {}
    }

    function openPopup() {
      root.classList.add("is-visible");
      root.setAttribute("aria-hidden", "false");

      if (emailInput) {
        setTimeout(function () {
          try {
            emailInput.focus();
          } catch (e) {}
        }, 50);
      }
    }

    function closePopup(markDismissed) {
      root.classList.remove("is-visible");
      root.setAttribute("aria-hidden", "true");

      if (markDismissed) setDismissed();

      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    // Close handlers
    root.addEventListener("click", function (e) {
      var t = e.target;
      if (t && t.closest && t.closest("[data-foxden-close]")) {
        e.preventDefault();
        closePopup(true);
      }
    });

    // ESC
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && root.classList.contains("is-visible")) {
        closePopup(true);
      }
    });

    // Copy code
    if (copyBtn && codeEl) {
      copyBtn.addEventListener("click", function () {
        var code = (codeEl.textContent || "").trim() || "FOXDEN10";

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            if (copyMsg) {
              copyMsg.style.display = "block";
              setTimeout(function () {
                copyMsg.style.display = "none";
              }, 2000);
            }
          });
          return;
        }

        try {
          var ta = document.createElement("textarea");
          ta.value = code;
          ta.style.position = "fixed";
          ta.style.left = "-9999px";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);

          if (copyMsg) {
            copyMsg.style.display = "block";
            setTimeout(function () {
              copyMsg.style.display = "none";
            }, 2000);
          }
        } catch (err) {}
      });
    }

    // Create hidden iframe + force form to submit into it (no redirects, Shopify-native submit still runs)
    function ensureIframeTarget() {
      if (!form) return;

      var iframeName = "foxden_newsletter_iframe";
      var existing = document.querySelector('iframe[name="' + iframeName + '"]');
      if (!existing) {
        var iframe = document.createElement("iframe");
        iframe.name = iframeName;
        iframe.style.display = "none";
        iframe.width = "0";
        iframe.height = "0";
        iframe.setAttribute("aria-hidden", "true");
        document.body.appendChild(iframe);
      }

      form.setAttribute("target", iframeName);
      // Make sure action is clean (avoid theme hash behaviours)
      var action = form.getAttribute("action") || "";
      if (!action || action.indexOf("/contact") === -1) {
        form.setAttribute("action", "/contact");
      } else {
        // strip any #hash
        form.setAttribute("action", action.split("#")[0]);
      }
    }

    ensureIframeTarget();

    // Submit handler (LET SHOPIFY SUBMIT HAPPEN)
    if (form) {
      form.addEventListener("submit", function (e) {
        ensureIframeTarget();

        var email = emailInput ? emailInput.value : "";
        if (!isValidEmail(email)) {
          e.preventDefault();
          if (emailInput) {
            emailInput.focus();
            emailInput.style.borderColor = "#d64545";
          }
          return;
        }

        if (hasSubmitted) {
          e.preventDefault();
          return;
        }
        hasSubmitted = true;

        if (emailInput) emailInput.style.borderColor = "";

        // Show success UI immediately, but DO NOT block Shopify submit
        if (success) success.hidden = false;
        form.style.display = "none";
        if (declineBtn) declineBtn.style.display = "none";

        setDismissed();

        closeTimer = setTimeout(function () {
          closePopup(true);
        }, SUCCESS_CLOSE_MS);
      });
    }

    // Open after delay
    openTimer = setTimeout(openPopup, POPUP_DELAY_MS);

    window.addEventListener("beforeunload", function () {
      if (openTimer) clearTimeout(openTimer);
      if (closeTimer) clearTimeout(closeTimer);
    });
  });
})();
